// import reverbEdit from "./edit.vue";
import waterList from "./list.vue";
// import reverbInfo from "./info.vue";
let a = Object.assign({ waterList });
export default a;
